var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content orderImport" },
    [
      _vm.editableRecord
        ? _c("updateBlackList", {
            attrs: {
              drug: _vm.editableRecord,
              type: "autolist",
              closeModal: _vm.closeModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.countries
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "form-group m-r-10 mb-0" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Выберите страну"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedCountry,
                          expression: "selectedCountry",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedCountry = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.countries, function (name, index) {
                      return _c("option", { domProps: { value: index } }, [
                        _vm._v(_vm._s(name)),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "btn btn-info align-self-end",
                          "data-style": "zoom-in",
                          loading: _vm.btnLoading,
                        },
                        on: { click: _vm.getDrugs },
                      },
                      [_vm._v("Просчитать список\n            ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("pulse-loader", {
                attrs: { loading: _vm.loading, color: _vm.color },
              }),
            ],
            1
          ),
          _vm._v(" "),
          false && _vm.drugs
            ? _c("div", [
                _c("div", { attrs: { id: "printTable" } }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-sm table-hover default_table table-striped",
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.drugs, function (drug, index) {
                          return _c(
                            "tr",
                            {
                              class:
                                _vm.selectedCountry != drug.income_country_id
                                  ? "bg-danger"
                                  : "",
                            },
                            [
                              _c("td", [_vm._v(_vm._s(index + 1))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(drug.title) +
                                    " (" +
                                    _vm._s(drug.id) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    (_vm.storeRequest[drug.id] || 0) +
                                      _vm.getSumOfRequests(drug.id)
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.storeRequest[drug.id]) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.orderRequests[drug.id]) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.requestedDrugs
            ? _c("div", [
                _c("div", { staticClass: "flex flex-end" }, [
                  _c("div", { staticClass: "m-r-10" }, [
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.showAllStatistics,
                            expression: "showAllStatistics",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: { type: "checkbox", value: "", id: "ch11" },
                        domProps: {
                          checked: Array.isArray(_vm.showAllStatistics)
                            ? _vm._i(_vm.showAllStatistics, "") > -1
                            : _vm.showAllStatistics,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = _vm.showAllStatistics,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showAllStatistics = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showAllStatistics = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showAllStatistics = $$c
                              }
                            },
                            _vm.updateAllStats,
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "ch11" },
                        },
                        [_vm._v("Раскрыть все детали")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: { click: _vm.printTable },
                      },
                      [_vm._v("Печать")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "printTable" } }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-hover default_table table-striped",
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.sortedDrugs(), function (drug, index) {
                          return _c(
                            "tr",
                            {
                              class:
                                _vm.selectedCountry != drug.country
                                  ? "bg-danger"
                                  : "",
                            },
                            [
                              _c("td", [_vm._v(_vm._s(index + 1))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(drug.name) +
                                    " (" +
                                    _vm._s(drug.id) +
                                    ")\n                  "
                                ),
                                drug.pack_set && drug.pack_set !== 1
                                  ? _c("p", { staticClass: "pack_comment" }, [
                                      _vm._v("Препарат комплектный: "),
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-info" },
                                        [_vm._v("1 комплект")]
                                      ),
                                      _vm._v(" - "),
                                      _c("strong", [
                                        _vm._v(_vm._s(drug.pack_set)),
                                      ]),
                                      _vm._v("\n                    (зав.уп.)"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                drug.pack_box_comment
                                  ? _c(
                                      "p",
                                      { staticClass: "pack_box_comment" },
                                      [_vm._v(_vm._s(drug.pack_box_comment))]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.printQty(drug)) + " "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.printReserve(drug)),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "hide_print" }, [
                                _c("div", { staticClass: "form-check" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: drug.visibleStatistics,
                                        expression: "drug.visibleStatistics",
                                      },
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      type: "checkbox",
                                      value: "",
                                      id: `defaultCheck${drug.id}`,
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        drug.visibleStatistics
                                      )
                                        ? _vm._i(drug.visibleStatistics, "") >
                                          -1
                                        : drug.visibleStatistics,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = drug.visibleStatistics,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = "",
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  drug,
                                                  "visibleStatistics",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  drug,
                                                  "visibleStatistics",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              drug,
                                              "visibleStatistics",
                                              $$c
                                            )
                                          }
                                        },
                                        _vm.updateStatVisibility,
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "form-check-label",
                                      attrs: { for: `defaultCheck${drug.id}` },
                                    },
                                    [_vm._v("Показать / скрыть")]
                                  ),
                                ]),
                                _vm._v(" "),
                                drug.visibleStatistics
                                  ? _c("div", [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table-bordered info_table",
                                        },
                                        [
                                          _c("thead", [
                                            _c(
                                              "tr",
                                              [
                                                _c("th"),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.storeNames,
                                                  function (store) {
                                                    return _c("th", [
                                                      _vm._v(_vm._s(store)),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "tr",
                                            [
                                              _c("td", [_vm._v("На складе")]),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.storeNames,
                                                function (store, index) {
                                                  return _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.inStore[index][
                                                          drug.id
                                                        ]
                                                          ? _vm.inStore[index][
                                                              drug.id
                                                            ]
                                                          : ""
                                                      )
                                                    ),
                                                  ])
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "tr",
                                            [
                                              _c("td", [_vm._v("Бронь")]),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.storeNames,
                                                function (store, index) {
                                                  return _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.orderRequests[
                                                          index
                                                        ] &&
                                                          _vm.orderRequests[
                                                            index
                                                          ].total
                                                          ? _vm.orderRequests[
                                                              index
                                                            ].total[drug.id]
                                                          : ""
                                                      )
                                                    ),
                                                  ])
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "tr",
                                            [
                                              _c("td", [_vm._v("Запас")]),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.storeNames,
                                                function (store, index) {
                                                  return _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.storeRequest[index]
                                                          ? _vm.storeRequest[
                                                              index
                                                            ][drug.id]
                                                          : ""
                                                      )
                                                    ),
                                                  ])
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "hide_print" },
                                [
                                  _c(
                                    "dropdown-menu",
                                    {
                                      attrs: {
                                        interactive: true,
                                        closeOnClickOutside: true,
                                      },
                                      model: {
                                        value: drug.showDropDown,
                                        callback: function ($$v) {
                                          _vm.$set(drug, "showDropDown", $$v)
                                        },
                                        expression: "drug.showDropDown",
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-default dropdown-toggle1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-ellipsis-v",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editRecord(drug)
                                                },
                                              },
                                            },
                                            [_vm._v("Игнорирование")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: { click: _vm.printTable },
                    },
                    [_vm._v("Печать")]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.ignoredDrugs.length
        ? _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "table",
                { staticClass: "table table-sm table-hover table-striped" },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.sortedDrugs(true), function (drug, index) {
                      return _c(
                        "tr",
                        {
                          class:
                            _vm.selectedCountry != drug.country
                              ? "bg-danger"
                              : "",
                        },
                        [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n              " +
                                _vm._s(drug.name) +
                                " (" +
                                _vm._s(drug.id) +
                                ")\n              "
                            ),
                            drug.pack_comment
                              ? _c("p", { staticClass: "pack_comment" }, [
                                  _vm._v(_vm._s(drug.pack_comment)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            drug.pack_box_comment
                              ? _c("p", { staticClass: "pack_box_comment" }, [
                                  _vm._v(_vm._s(drug.pack_box_comment)),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.printQty(drug)) + " "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.printReserve(drug)),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "hide_print" }, [
                            _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: drug.visibleStatistics,
                                    expression: "drug.visibleStatistics",
                                  },
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "checkbox",
                                  value: "",
                                  id: `defaultCheck${drug.id}`,
                                },
                                domProps: {
                                  checked: Array.isArray(drug.visibleStatistics)
                                    ? _vm._i(drug.visibleStatistics, "") > -1
                                    : drug.visibleStatistics,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = drug.visibleStatistics,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              drug,
                                              "visibleStatistics",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              drug,
                                              "visibleStatistics",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(drug, "visibleStatistics", $$c)
                                      }
                                    },
                                    _vm.updateStatVisibility,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: `defaultCheck${drug.id}` },
                                },
                                [_vm._v("Показать / скрыть")]
                              ),
                            ]),
                            _vm._v(" "),
                            drug.visibleStatistics
                              ? _c("div", [
                                  _c(
                                    "table",
                                    {
                                      staticClass: "table-bordered info_table",
                                    },
                                    [
                                      _c("thead", [
                                        _c(
                                          "tr",
                                          [
                                            _c("th"),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.storeNames,
                                              function (store) {
                                                return _c("th", [
                                                  _vm._v(_vm._s(store)),
                                                ])
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tr",
                                        [
                                          _c("td", [_vm._v("На складе")]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.storeNames,
                                            function (store, index) {
                                              return _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.inStore[index][drug.id]
                                                      ? _vm.inStore[index][
                                                          drug.id
                                                        ]
                                                      : ""
                                                  )
                                                ),
                                              ])
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "tr",
                                        [
                                          _c("td", [_vm._v("Бронь")]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.storeNames,
                                            function (store, index) {
                                              return _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.orderRequests[index] &&
                                                      _vm.orderRequests[index]
                                                        .total
                                                      ? _vm.orderRequests[index]
                                                          .total[drug.id]
                                                      : ""
                                                  )
                                                ),
                                              ])
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "tr",
                                        [
                                          _c("td", [_vm._v("Запас")]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.storeNames,
                                            function (store, index) {
                                              return _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.storeRequest[index]
                                                      ? _vm.storeRequest[index][
                                                          drug.id
                                                        ]
                                                      : ""
                                                  )
                                                ),
                                              ])
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moment(
                                  drug.black_list.actual_date,
                                  "DD.MM.YYYY"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "dropdown-menu",
                                {
                                  attrs: {
                                    closeOnClickOutside: true,
                                    interactive: true,
                                  },
                                  model: {
                                    value: drug.showDropDown,
                                    callback: function ($$v) {
                                      _vm.$set(drug, "showDropDown", $$v)
                                    },
                                    expression: "drug.showDropDown",
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-default dropdown-toggle1",
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-ellipsis-v",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item pointer",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editRecord(drug)
                                            },
                                          },
                                        },
                                        [_vm._v("Игнорирование")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { attrs: { width: "50%" } }, [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запрос")]),
        _vm._v(" "),
        _c("th", { staticClass: "hide_print" }, [_vm._v("Детали")]),
        _vm._v(" "),
        _c("th", { staticClass: "hide_print" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { attrs: { width: "50%" } }, [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запрос")]),
        _vm._v(" "),
        _c("th", { staticClass: "hide_print" }, [_vm._v("Детали")]),
        _vm._v(" "),
        _c("th", { staticClass: "hide_print" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Препараты, которые игнорированны для просчета")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запрос")]),
        _vm._v(" "),
        _c("th", { staticClass: "hide_print" }, [_vm._v("Детали")]),
        _vm._v(" "),
        _c("th", [_vm._v("Актуально до")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }